/** Builds likely email addresses for a person from an agency's email pattern, e.g. "[first][last]@aka.nyc" or "first.last@agency.com". */
export function guessEmails(name: string, pattern: string, fallbackDomain = ''): string[] {
  const parts = name.toLowerCase().normalize('NFKD').replace(/[^a-z\s'-]/g, '').replace(/['-]/g, '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return [];
  const first = parts[0] ?? '';
  const last = parts.length > 1 ? parts[parts.length - 1] ?? '' : '';
  const p = pattern.toLowerCase().replace(/\s/g, '');
  const domain = (p.split('@')[1] ?? fallbackDomain).replace(/[^a-z0-9.-]/g, '');
  if (!domain || !first) return [];
  const out: string[] = [];
  const local = (p.split('@')[0] ?? '').replace(/[[\]{}()<>]/g, '').replace(/firstname/g, 'first').replace(/lastname/g, 'last').replace(/firstinitial|first_initial/g, 'f').replace(/lastinitial|last_initial/g, 'l');
  if (local && /first|last|\bf|l\b/.test(local)) {
    const built = local.replace(/first|last|f|l/g, (t) => (t === 'first' ? first : t === 'last' ? last : t === 'f' ? first[0] ?? '' : last[0] ?? ''));
    if (/^[a-z0-9._-]+$/.test(built)) out.push(`${built}@${domain}`);
  }
  const common = last ? [`${first}${last}`, `${first}.${last}`, `${first[0]}${last}`, first, `${first}_${last}`] : [first];
  for (const c of common) out.push(`${c}@${domain}`);
  return [...new Set(out)].slice(0, 5);
}
